<template>
    <transition name="slide">
        <div class="modal fade" @keyup.enter="ACTION()" tabindex="-1" role="dialog" :class="onreload ? 'show' : 'show'" :style="onreload ? 'display: block; padding-left: 0px;' : ''">
            <div class="modal-dialog modal-dialog-centered">
                <form class="modal-content shadow-3" @submit.prevent="ACTION()">
                    <div class="modal-header">
                        <div class="icon icon-shape rounded-3 text-lg me-4" :class="`${item.state_id == 25 ? 'bg-soft-primary text-primary' : (item.revert == true ? 'bg-soft-danger text-danger' : 'bg-soft-success text-success')}`">
                            <i :class="`${item.state_id == 25 ? 'fa-solid fa-truck-fast' : (item.revert == true ? 'fa-solid fa-truck-fast fa-flip-horizontal' : 'fa-solid fa-check')}`"></i>
                        </div>
                        <div>
                            <h5 class="mb-1">{{ item.state_id == 25 ? 'Entregar' : (item.revert == true ? (item.state_id == 27 ? 'Abrir' : 'Devolver') : 'Completar') }} Ruta</h5>
                            <small class="d-block text-xs text-muted">¿Realmente desea {{ item.state_id == 25 ? 'Entregar' : (item.revert == true ? (item.state_id == 27 ? 'Abrir' : 'Devolver') : 'Completar') }} esta ruta?</small>
                        </div>
                        <div class="ms-auto">
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="d-flex align-items-center">
                            <div>
                                <p class="text-sm">Ingresa tu contraseña para permitir esta acción</p>
                            </div>
                        </div>
                        <div>
                            <v-text-field
                                v-model="password"
                                :append-icon="type ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="type ? 'text' : 'password'"
                                class="form-control form-control-sm"
                                :class="errors.password ? 'is-invalid' : ''"
                                hide-details
                                @click:append="type = !type">
                            </v-text-field>
                            <small class="invalid-feedback" v-for="(error, index) in errors.password" :key="index">{{ error }}</small>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="submit" class="btn btn-h btn-primary px-3">
                            <div class="spinner-border spinner-border-sm" role="status" v-if="count >= 1">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <span v-else>{{ item.state == 25 ? 'Entregar' : (item.revert == true ? (item.state_id == 27 ? 'Abrir' : 'Devolver') : 'Completar') }}</span>
                        </button>
                        <button type="button" class="btn btn-h btn-dark px-3" @click="$emit('onclose')">Cancelar</button>
                    </div>
                </form>
            </div>
        </div>
    </transition>
</template>
<script>
export default{
    props: ['onreload', 'item'],
    data(){
        return{
            password: '',
            type: false,
            count: 0,
            errors: {}
        }
    },
    created(){
        let vue = this
        vue.$nextTick(() => vue.$refs.modalContainer.focus())
    },
    methods: {
        ACTION: function(){
            let vue = this
            vue.count++
            if(vue.count == 1){
                let state_id = 0
                if(vue.item.state_id == 25){
                    state_id = 26
                }else{
                    if(vue.item.state_id == 26){
                        if(vue.item.revert == true){
                            state_id = 25
                        }else{
                            state_id = 27
                        }
                    }else if(vue.item.state_id == 27){
                        state_id = 26
                    }
                }
                if(state_id != 0){
                    let data = {
                        state_id: state_id,
                        password: vue.password
                    }
                    axios({url: '/change/state/deliver-routes/' + vue.item.id, method: 'PUT', data: data })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.$emit('onreload', resp.data.data)
                    })
                    .catch((err) => {
                        if(err.response.status !== 422){
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.errors = err.response.data
                        }
                    })
                    .finally((resp)=>{
                        vue.count = 0
                    })
                }else{
                    vue.count = 0
                }
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/delivery-routes/modals/Reload.vue